import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";

import WeatherTemperature from "./WeatherTemperature";
import ShowWeather from "./ShowWeather";
import WeatherData from "./WeatherData";
import WeatherForecast from "./WeatherForecast";
import "./Weather.css";

export default function SearchEngine() {
  const [city, setCity] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [weather, setWeather] = useState({});

  function handleSubmit(event) {
    event.preventDefault();

    function displayWeather(response) {
      setHasSearched(true);
      setWeather({
        temperature: response.data.temperature.current,
        humidity: response.data.temperature.humidity,
        wind: response.data.wind.speed,
        description: response.data.condition.description,
        icon: `https://shecodes-assets.s3.amazonaws.com/api/weather/icons/${response.data.condition.icon}.png`,
        date: new Date(response.data.time * 1000),
        coordinates: response.data.coordinates,
      });
    }

    let url = `https://api.shecodes.io/weather/v1/current?query=${city}}&key=7t8a34ad805a2b111fe3f7461ao070e4&units=metric`;
    axios.get(url).then(displayWeather);
  }

  function updateCity(event) {
    if (event.target.value) {
      setCity(event.target.value);
    } else {
      setHasSearched(false);
    }
  }

  return (
    <div>
      <div className="container">
        <div class="row">
          <form class="search-form" onSubmit={handleSubmit}>
            <input
              class="search-bar"
              type="text"
              placeholder="Search for city weather"
              onChange={updateCity}
            />
            <input class="search-btn" type="submit" value="🔍" />
          </form>
        </div>
      </div>

      {hasSearched && (
        <span>
          <span class="container">
            <span class="row mt-5 responsiv-600 d-flex justify-content-between ms-4 me-4">
              <div class="col-6 self-align-center">
                <WeatherData
                  showCity={city}
                  showDescription={weather.description}
                  showIcon={weather.icon}
                />
                <WeatherTemperature celsius={weather.temperature} />
              </div>

              <ShowWeather
                currentDate={weather.date}
                currentHumidity={weather.humidity}
                currentWind={weather.wind}
              />
            </span>
          </span>

          <WeatherForecast coordinates={weather.coordinates} />
        </span>
      )}
    </div>
  );
}
